module.exports = __webpack_public_path__ + "static/media/cz.d6dd48f8.png";